import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ProductCard from '../ProductCard/ProductCard';
import { products } from '../../data/products';
import './FeaturedProducts.css';

const brands = ['Nike', "Levi's", 'Calvin Klein', 'Michael Kors', 'Coach', 'Tommy Hilfiger'];

const FeaturedProducts = () => {
  const [activeTab, setActiveTab] = useState('all');

  const filteredProducts = useMemo(() => {
    switch (activeTab) {
      case 'sale': return products.filter((p) => p.salePrice).slice(0, 10);
      case 'new': return products.filter((p) => p.badge === 'NEW').slice(0, 10);
      case 'bestseller': return products.filter((p) => p.badge === 'BEST SELLER').slice(0, 10);
      default: return products.slice(0, 10);
    }
  }, [activeTab]);

  const tabs = [
    { id: 'all', label: 'All' },
    { id: 'sale', label: 'On Sale' },
    { id: 'new', label: 'New Arrivals' },
    { id: 'bestseller', label: 'Best Sellers' },
  ];

  return (
    <section className="featured-products">
      <div className="featured-products-header">
        <h2 className="featured-products-title">Featured Products</h2>
        <div className="featured-products-tabs">
          {tabs.map((tab) => (
            <button key={tab.id} className={`featured-products-tab ${activeTab === tab.id ? 'active' : ''}`} onClick={() => setActiveTab(tab.id)}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="featured-products-grid">
        {filteredProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '24px' }}>
        <Link to="/shop" className="featured-products-view-all">View All Products <ArrowRight size={16} /></Link>
      </div>

      <div className="featured-sale-banner">
        <div className="featured-sale-content">
          <h3>One Day Sale!</h3>
          <p>Extra 30% off select items. Use code: EXTRA30</p>
        </div>
        <Link to="/sale" className="featured-sale-cta">Shop Sale <ArrowRight size={16} /></Link>
      </div>

      <div className="featured-brands">
        <h3 className="featured-brands-title">Shop by Brand</h3>
        <div className="featured-brands-grid">
          {brands.map((brand) => (
            <Link key={brand} to={`/shop?brand=${encodeURIComponent(brand)}`} className="featured-brand-card">
              <p className="featured-brand-logo">{brand}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
